import Vue from 'vue';
import axios from 'axios';

var baseUrl = process.env.apiUrl;

export default {
  authenticate(username, password) {
    return axios.post(baseUrl + '/authenticate', { username: username, password: password });
  },

  checkToken(accessToken) {
    return axios.post(baseUrl + '/checktoken', { accessToken: accessToken})
      .then((res) => {
        if(res.data.valid && res.data.valid == true) {
          return true;
        }
        else {
          return false;
        }
      })
      .catch((err) => {
        return false;
      });
  },

  logout(router) {
    return axios.post(baseUrl + '/logout', { accessToken: localStorage.getItem('accessToken') })
      .then((res) => {
        logoutClientSide();
      })
      .catch((err) => {
        // Still logout client side even if the server failed to remove the access token
        logoutClientSide();
      })

    function logoutClientSide() {
      // Reset the route token checking
      window.initialRouteChecked = false;

      // Remove the access token from local storage
      localStorage.removeItem('accessToken');
      localStorage.removeItem('homeRoute');
      localStorage.removeItem('parentId');
      localStorage.removeItem('userGroup');
      localStorage.removeItem('userId');
      localStorage.removeItem('userObject');

      // Redirect to the login page
      document.location.href="/";
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/AuthenticationService.js